import { QueryClient } from "@tanstack/react-query";

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          // Don't retry auth errors — they're not transient
          if (isUnauthorized(error) || isForbidden(error)) return false;
          return failureCount < 3;
        },
      },
    },
  });
}

function isUnauthorized(error: unknown): boolean {
  return isTrpcCode(error, "UNAUTHORIZED");
}

function isForbidden(error: unknown): boolean {
  return isTrpcCode(error, "FORBIDDEN");
}

function isTrpcCode(error: unknown, code: string): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    "data" in error &&
    typeof (error as { data: unknown }).data === "object" &&
    (error as { data: { code?: string } }).data !== null &&
    (error as { data: { code?: string } }).data?.code === code
  );
}
